/**
 * @generated SignedSource<<7ef62240569ec0ed19c5dfaa43a4d878>>
 * @relayHash 6f7a66a68d6eb93ad1d4375599a5763b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ff902c72698b02103cca1a8a0163822692d270334df6f7b3a640c5a0233a3517

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessTimelineQuery } from './src_jiraBusinessTimelineQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ff902c72698b02103cca1a8a0163822692d270334df6f7b3a640c5a0233a3517",
    "metadata": {},
    "name": "src_jiraBusinessTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
